<template>
  <section class="bg-box">
    <section
      :class="{ 'show-box': true, active: active === index }"
      :style="{
        'font-size': $i18n.lang === 'en-us' ? (data.length > 3 ? '10px' : '12px') : '13px'
      }"
      v-for="(item, index) in data"
      :key="item"
      @click="handleClick(index)"
    >
      {{ item }}
    </section>
    <section class="animation">
      <section class="active" :style="`transform: translateX(${active}00%);`" />
      <section v-for="item in data.length - 1" :key="item" class="show-box" />
    </section>
  </section>
</template>

<script>
export default {
  name: 'BtnTabs',
  model: {
    prop: 'active',
    event: 'handleClick'
  },
  props: {
    data: Array,
    active: Number
  },
  methods: {
    handleClick(index) {
      this.$emit('handleClick', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 35px;
  background: var(--bg-color-7);
  border-radius: 9999px;

  .show-box,
  .active {
    z-index: 10;
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    white-space: nowrap;
    align-items: center;
    font-size: 13px;
    color: #778691;
  }

  & > .active {
    color: var(--font-color-1);
    font-weight: bold;
  }

  .animation {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;

    .active {
      transition: 0.3s all;
      z-index: 1;
      margin: 2px;
      height: calc(100% - 2px);
      background-color: var(--bg-color-6);
      border-radius: 9999px;
    }
  }
}
</style>
